import type { ConsoleRow } from "../api";

/** Keep the workspace/base path, and open the chosen record's review card. */
export function reviewRecordHref(base: string, item: Pick<ConsoleRow, "id" | "jobSiteId" | "visitId">): string {
  const url = new URL(base, "http://console.local");
  url.searchParams.set("page", "review");
  for (const key of ["view", "item", "cat", "needsok", "from", "to", "date", "project"]) url.searchParams.delete(key);
  url.searchParams.set("site", item.jobSiteId);
  if (item.visitId) url.searchParams.set("walk", item.visitId);
  else url.searchParams.delete("walk");
  url.searchParams.set("reviewing", item.visitId ?? `no-walk:${item.jobSiteId}`);
  url.searchParams.set("reviewItem", item.id);
  return `${url.pathname}${url.search}`;
}
